import React from 'react';
import { HashRouter, useLocation } from 'react-router-dom';
import AppRoutes from './routes';
import { DataProvider } from './data/DataProvider';
import { ToastProvider } from './shared/components/ToastProvider';
import { registerServiceWorker } from './pwa/registerSW';
import { pb, pbPortal, pbEngineer, setActivePb } from './lib/pb';
import './App.css';

// Flip the active PocketBase client (admin store ↔ portal store ↔ engineer store) as the
// user navigates between /admin, /portal and /engineer so DataProvider always talks
// to the session that owns the current screen (E5/E1/engineer).
function AuthScopeWatcher() {
  const location = useLocation();
  React.useEffect(() => {
    const isPortal = location.pathname.startsWith('/portal');
    const isEngineer = location.pathname.startsWith('/engineer');
    
    if (isEngineer) {
      setActivePb(pbEngineer);
    } else if (isPortal) {
      setActivePb(pbPortal);
    } else {
      setActivePb(pb);
    }
  }, [location.pathname]);
  return null;
}

export default function App() {
  // Branding is applied by DataProvider (agency) / PortalAuthGate (portal)
  // once the tenant is known; registerSW stays side-effect free.
  if ('serviceWorker' in navigator) {
    registerServiceWorker();
  }

  return (
    <ToastProvider>
      <DataProvider>
        <HashRouter>
          <AuthScopeWatcher />
          <AppRoutes />
        </HashRouter>
      </DataProvider>
    </ToastProvider>
  );
}
